export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-phone-line',
      title: 'Gestión de Cobranza',
      description: 'Recuperación efectiva de cartera vencida mediante estrategias personalizadas y profesionales que respetan los derechos del deudor.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Asesoría Financiera',
      description: 'Orientación experta para la reestructuración de deudas y planes de pago adaptados a las capacidades económicas de cada cliente.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Negociación de Acuerdos',
      description: 'Mediación profesional entre acreedores y deudores para alcanzar soluciones beneficiosas y sostenibles para ambas partes.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Atención Personalizada',
      description: 'Servicio dedicado con un equipo capacitado que entiende las necesidades específicas de cada caso y ofrece soluciones a medida.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full mb-6">
            <i className="ri-service-line text-3xl text-amber-600"></i>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Nuestros Servicios</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Ofrecemos soluciones integrales de cobranza con un enfoque ético y profesional
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white p-8 hover:shadow-xl transition-all duration-300 group border border-gray-100 hover:border-amber-200"
            >
              <div className="w-16 h-16 bg-amber-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-amber-100 transition-colors">
                <i className={`${service.icon} text-3xl text-amber-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
